__turbopack_context__.v({
  "actions": "PhoneFeatures-module-scss-module__bxrRaW__actions",
  "active": "PhoneFeatures-module-scss-module__bxrRaW__active",
  "collapsed": "PhoneFeatures-module-scss-module__bxrRaW__collapsed",
  "content": "PhoneFeatures-module-scss-module__bxrRaW__content",
  "expanded": "PhoneFeatures-module-scss-module__bxrRaW__expanded",
  "feature": "PhoneFeatures-module-scss-module__bxrRaW__feature",
  "featureText": "PhoneFeatures-module-scss-module__bxrRaW__featureText",
  "featureTitle": "PhoneFeatures-module-scss-module__bxrRaW__featureTitle",
  "features": "PhoneFeatures-module-scss-module__bxrRaW__features",
  "grid": "PhoneFeatures-module-scss-module__bxrRaW__grid",
  "icon": "PhoneFeatures-module-scss-module__bxrRaW__icon",
  "label": "PhoneFeatures-module-scss-module__bxrRaW__label",
  "phone": "PhoneFeatures-module-scss-module__bxrRaW__phone",
  "phoneBase": "PhoneFeatures-module-scss-module__bxrRaW__phoneBase",
  "phoneScreen": "PhoneFeatures-module-scss-module__bxrRaW__phoneScreen",
  "root": "PhoneFeatures-module-scss-module__bxrRaW__root",
  "screenImage": "PhoneFeatures-module-scss-module__bxrRaW__screenImage",
  "text": "PhoneFeatures-module-scss-module__bxrRaW__text",
  "title": "PhoneFeatures-module-scss-module__bxrRaW__title",
});
